<template>
  <div class="card">
    <div class="card-header">
      <div>
        <span
          v-for="lieu in lieux"
          :key="lieu"
          class="badge"
          :style="{ backgroundColor: getBadgeColor(lieu) }"
        >
          {{ lieu }}
        </span>
      </div>
      <div
        class="media"
        :class="`fit-${fit}`"
        :style="image ? { backgroundImage: `url(${imageSrc})` } : {}"
        aria-label="Image de l'association"
        role="img"/>
      <h4>{{ nom }}</h4>
    </div>

    <div class="card-content">
      <h4>{{ description }}</h4>
    </div>
    <div class="card-footer">
      <button @click="$emit('select', $attrs[':key'] ? $attrs[':key'] : nom)">
        Voir plus
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssoComponent',
  props: {
    nom: String,
    description: String,
    lieux: Array,
    image: String,
    fit: { type: String, default: 'cover' } // 'cover' (uniforme/zoom) ou 'contain' (logos)
  },
  computed: {
    imageSrc() {
      if (this.image?.startsWith('data:image')) return this.image;
      return `data:image/png;base64,${this.image}`;
    }
  },
  methods: {
    badgePalette() {
      return [
        '#6B4423', // teal
        '#D49B3F', // mustard
        '#167580', // dark brown
        '#9E7BB5', // pastel mauve
        '#5A7C8A', // slate blue
        '#BDB76B', // khaki
        '#8A6E45', // earthy brown
        '#A3A0D8'  // pastel periwinkle
      ];
    },
    // simple hash string → integer
    hashString(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash);
    },
    // choix de couleur en fonction du lieu
    getBadgeColor(lieu) {
      const palette = this.badgePalette();
      const idx = this.hashString(lieu) % palette.length;
      return palette[idx];
    }
  }
}
</script>


<style scoped>
.card {
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  height: 380px;
  width: 300px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

/* Zone image uniforme : 25% de la hauteur de la carte, quoi qu'il arrive */
.media {
  flex: 0 0 70%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f3f4f6; /* fond neutre si image absente */
}

/* Mode par défaut : zoom/cadre pour remplir (logo petit => zoomé) */
.fit-cover { background-size: cover; }

/* Optionnel : pour de vrais logos qu'on ne veut pas recadrer */
.fit-contain { background-size: contain; }

/* Titre sous l’image, peut prendre plusieurs lignes et pousse le texte */
.title {
  color: #000;
  font-size: 1.2rem;
  margin: 10px 0;
  text-align: center;
  word-wrap: break-word;
}


.card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  transform: translateY(-5px);
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #1E1C66;
}

.badge {
  display: inline-block;
  color: white;
  border-radius: 6px;
  padding: 2px 8px;
  margin-right: 4px;
  font-size: 0.8em;
  margin-bottom: 5px;
}

/* ✅ Image prend toujours 25% de la hauteur de la carte */
.asso-image {
  width: 100%;
  flex: 0 0 25%;
  object-fit: cover;
}

.card-header h4 {
  color: black;
  font-size: 1.2rem;
  margin: 10px 0;
  justify-content: flex-start;
  text-align: center;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}


.card-content {
  flex: 1; /* prend tout l’espace dispo entre header et footer */
  margin: 10px 0;
  text-align: center;
  color: #1E1C66;
  font-size: 0.9rem;
  overflow-y: auto; /* scroller si trop long */
}

.card-footer {
  flex-shrink: 0;
  margin-top: auto; /* ✅ reste collé en bas */
}

.card-footer > button {
  background-color: #D49B3F;
  color: white;
  border-radius: 6px;
  border: none;
  padding: 0.5rem;
  font-weight: bold;
  transition: background-color 0.2s;
  width: 100%; /* pour que le bouton s’adapte bien */
}

.card-footer > button:hover {
  background-color: #B67F33;
}

</style>
